import { useBrokersServiceBrokersTeamsListKey } from '@insurance/api/queries'
import { BrokersService } from '@insurance/api/requests'
import { InfiniteSelect } from '@shared/components'
import { SelectProps } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = { ids?: string; broker?: string } & SelectProps

export const BrokerTeamSelect = ({ ids, broker, ...props }: Props) => {
  const { t } = useTranslation()

  return (
    <InfiniteSelect
      placeholder={t('team')}
      apiCall={({ pageParam, pageSize, search }) =>
        BrokersService.brokersTeamsList(
          broker,
          undefined,
          ids,
          undefined,
          undefined,
          pageParam,
          pageSize,
          search
        )
      }
      queryKey={[useBrokersServiceBrokersTeamsListKey, ids, broker]}
      getOption={({ id, name }) => ({
        label: name,
        value: String(id)
      })}
      {...props}
    />
  )
}
